/**
 * @module surveyElementResults
 */
import { createReducer } from '@reduxjs/toolkit';
import { surveyReportingActions } from '~/behaviors/actions/survey_reporting.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeSurveyElementResults = (state, action) => {
  const surveyElementResults = action.payload?.entities?.surveyElementResults || {};
  return {
    ...state,
    ...surveyElementResults,
  };
};

const mergeAttributeSurveyElementResults = (state, action) => {
  const surveyElementResults = action.payload?.entities?.surveyElementResults || {};

  Object.keys(surveyElementResults).forEach((surveyElementId) => {
    state[surveyElementId] = {
      ...state[surveyElementId],
      attributeResults: [
        ...state[surveyElementId].attributeResults,
        ...surveyElementResults[surveyElementId].attributeResults,
      ],
    };
  });
};

const surveyElementResults = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);

  builder.addCase(surveyReportingActions.fetchReportingResults.fulfilled, mergeSurveyElementResults);

  builder.addCase(surveyReportingActions.fetchReportingAttributeResult.fulfilled, mergeAttributeSurveyElementResults);
});

export default surveyElementResults;
